module.exports = __webpack_public_path__ + "img/social_facebook.5812a2e.svg";